<template>
  <div class="table-dark-bg billing-table cart-table-wrapper">
    <b-table
      select-mode="single"
      ref="cartProducts"
      selectable
      :fields="fields"
      :busy="isBusy"
      :items="cartDetails"
      class="table cart-table mt-0 table-dark"
      v-if="cartDetails.length > 0"
      @row-selected="getProductDetails"
      :tbody-tr-class="outStock"
    >
      <template v-slot:cell(id)="data">
        <!-- <span v-if="salesPersonSelected != ''"> -->
        <div class="custom-check pt-0">
          <img
            src="@/assets/images/return.svg"
            alt
            class="mb-1"
            v-if="state.billing.billing.refund_mode"
          />
          <span v-if="salesPersonSelected == ''" v-text="data.item.id" />
          <span v-if="salesPersonSelected != ''">
            <input
              type="checkbox"
              :id="data.item.id"
              @change="assignSalePerson(data.item)"
              :value="data.item.salesman_id"
              :checked="isChecked(data.item.salesman_id)"
            />
            <label :for="data.item.id" />
          </span>
        </div>
        <!-- </span> -->
      </template>
      <template v-slot:cell(name)="data">
        <a
          href="javascript:void(0)"
          @click="showProductDetail(data)"
          class="product-name"
          :class="[data.item.stock <= 0 ? 'text-danger' : null]"
          v-text="splitTextOnBreakPoint(data.item.name)"
          />
        <br />
        <span style="color: #c0c0c0;" v-text="data.item.barcode" />
        <br />
        <span
          class="text-muted"
          v-if="data.item.offer_data.available_offers.length > 0"
          v-text="
            `${data.item.offer_data.available_offers.length} promotion(s) available`
          "
        />
        <span class="offer" v-else>No promotion available</span>
        <!-- <span class="offer" v-if="data.item.promotion == ''"
          >No promotions available</span> -->
        <span
          class="offer active"
          v-if="data.item.promotion != ''"
          v-b-tooltip.hover.bottomleft
          :title="data.item.promotion"
          v-text="data.item.promotion.slice(0, 35) + '..'"
        />
      </template>
      <template v-slot:cell(qty)="qty">
        <select
          class="custom-select custom-select-sm"
          @change="updateToCart(qty.item, $event.target.value)"
          v-if="!qty.item.weight"
        >
          <option
            v-for="(nqty, index) in parseInt(qty.item.available_qty)"
            v-bind:key="index"
            v-text="nqty"
            :value="nqty"
            :selected="nqty == qty.item.qty"
            :id="'cart-' + index"
          />
        </select>
        <b-button
          v-if="qty.item.weight"
          type="button"
          variant="outline-primary"
          block
          style="padding:6px;"
          @click="updateQty(qty.item)"
          :id="'weight-btn-' + index"
        >
          <span v-text="qty.item.qty + ' ' + qty.item.uom" />
        </b-button>
      </template>
      <template v-slot:cell(cart_id)="data">
        <div>
          <a
            href="javascript:void(0)"
            class="close"
            title="Delete Product"
            @click="removeProduct(data.item)"
          >
            <font-awesome-icon :icon="['fas', 'times']" />
          </a>
        </div>
      </template>
      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle" />
        <strong>Loading...</strong>
      </div>
    </b-table>
    <div
      v-else
      class="notification d-flex align-items-center text-center justify-content-center"
      style="height:100%; flex-direction: column"
    >
      <h6
        style="color: black !important;"
        v-text="`You are currently in ${getBillingMode} mode.`"
      />
      <p class="text-muted w-100">
        Start scanning or manually enter the
        <br />barcode to add products.
      </p>
    </div>
    <div>
      <b-modal
        ref="product-detail"
        size="lg"
        hide-footer
        centered
        class="product-detail"
        no-close-on-esc
        no-close-on-backdrop
      >
        <b-row v-if="productDetailPop != ''" style="margin-top:-40px">
          <!-- {{productDetailPop}} -->
          <div class="col-lg-2 " :class="[noImage == true ? 'd-none' : '']">
            <div>
              <div class="row">
                <div class="col-12 mb-3 main-img">
                  <img
                    :src="
                      productDetailPop.item.image_link +
                        productDetailPop.item.images[0]
                    "
                    alt
                    class="w-100 light-img box-shadow mb-1"
                  />
                  <!-- <img src="@/assets/images/DefIMG_Prod_DK.svg" alt class="w-100 dark-img box-shadow" />-->
                  <!-- <CoolLightBox 
                      :items="productImages" 
                      :index="index"
                      loop
                      @close="index = null">
                    </CoolLightBox> -->
                  <!-- 
                    <div class="images-wrapper">
                      <div
                        class="image mb-2 d-flex justify-content-center align-items-center"
                        v-for="(image, imageIndex) in productImages"
                        :key="imageIndex"
                        @click="setIndex(imageIndex)"
                        :style="{ backgroundImage: 'url(' + image.src + ')' }"
                      >
                      <font-awesome-icon size="2x" :icon="['fas', 'search-plus']"/>
                      </div>
                </div> -->
                </div>
              </div>

              <div
                class="row thumb-imgs"
                :class="{ 'd-none': productDetailPop.item.images.length < 2 }"
              >
                <div
                  class="col-6 mb-2"
                  v-for="images in productDetailPop.item.images"
                  :key="images"
                >
                  <img
                    :src="productDetailPop.item.image_link + images || img"
                    alt
                    @error="imageUrlAlt"
                    class="w-100 light-img box-shadow mb-1"
                  />
                </div>
              </div>
            </div>
            <!-- <p class="mt-4">
              <label for class="d-block pl-0">Barcode</label>

              <img src="@/assets/images/barcode.svg" alt />
              {{productDetailPop.item.barcode}}
            </p>-->
          </div>
          <div class="col-lg-10" :class="[noImage == true ? 'col-lg-12' : '']">
            <label
              for
              class="p-0"
              :class="{ 'd-none': (productDetailPop.item.brand_name = !'') }"
              v-text="productDetailPop.item.brand_name"
            />
            <label
              for
              class="p-0"
              :hidden="(productDetailPop.item.brand_name = !'')"
              >{{}}</label
            >

            <span
              class="barcode fs-12"
              v-text="productDetailPop.item.barcode"
            />
            <h5
              class="fw-normal mb-3 fs-18"
              v-text="productDetailPop.item.name"
            />
            <p
              class="mt-3 mb-4"
              :class="
                parseFloat(productDetailPop.item.stock) <= 0
                  ? 'text-danger'
                  : 'text-success'
              "
              v-text="productDetailPop.item.stock + ' Units Available'"
            />
            <!--<div class="mt-4 d-flex align-items-center justify-content-between">
              <h5 class="mb-0 fw-normal">
                {{ productDetailPop.item.sale_price }}
              </h5>

              <a
                v-b-toggle.multiCollapseExample1
                href="javascript:void(0)"
                v-if="productDetailPop.item.price_list.length > 1"
              >
                <font-awesome-icon :icon="['far', 'plus-square']" size="sm" />&nbsp; Click to view multiple prices
              </a>
            </div>-->

            <!--<b-collapse id="multiCollapseExample1">
              <div class="card-body py-2 px-3 border-0 mt-3 multi-price">
                <div
                  v-bind:key="price.id"
                  v-for="price in productDetailPop.item.price_list"
                  class="price"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 class="fw-normal mb-0">{{ currencySymbol }} {{ price }}</h6>
                    <input
                      type="radio"
                      :value="price.value"
                      name="amount"
                      class="form-control d-inline w-auto"
                      style="width: auto"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
            </b-collapse>-->
            <div class="mt-3 mb-1 product-information">
              <b-row>
                <b-col md="2">
                  <label for id="label-qty-productpopup">Qty. in Cart</label>
                  <custom-dropdown
                    class="fs-12"
                    :options="QtyOptions"
                    :currentValue="productDetailPop.item.qty"
                    @update-value="updateQtyPopUp"
                  />
                  <!-- <b-form-select  v-model="cartQty" class="fs-11"  :options="QtyOptions" >
                  </b-form-select>-->
                  <!-- <label for class="pl-0">Varient</label>
                  <b-form-group id="input-group-1">
                    <b-form-input
                      id
                      type="text"
                      required
                      placeholder="No Varients Avaliable"
                      :disabled="productDetailPop.item.variant == ''"
                    ></b-form-input>
                  </b-form-group>-->
                  <!--  <v-select
                    :options="varients"
                    v-model="varientsPlaceholder"
                    class="custom-vselect"
                  />-->
                </b-col>
                <b-col md="4">
                  <label for id="label-batch-productpopup">Select Batch</label>
                  <div v-if="!state.system.isOffline">
                    <b-input-group
                      class="select-batch"
                      @click="openSelectBatchModal"
                    >
                      <b-form-input
                        class="fs-11"
                        placeholder="Select/change batch"
                        disabled
                        style="cursor: no-drop;"
                      />
                      <template v-slot:append>
                        <font-awesome-icon
                          style="cursor: no-drop;"
                          :icon="['fa', 'angle-right']"
                        />
                      </template>
                    </b-input-group>
                  </div>
                  <div v-else>
                    <b-form-input
                      class="fs-11"
                      style="cursor: no-drop;"
                      placeholder="Batch selection is disabled"
                      disabled
                    />
                  </div>
                </b-col>
                <b-col md="3">
                  <label
                    id="label-price-override-productpopup"
                    v-text="
                      productDetailPop.item.price_override == 0
                        ? 'MRP'
                        : 'Overriden MRP'
                    "
                  />
                  <b-form-input
                    :placeholder="currencySymbol + '0.00'"
                    class="fs-11 highlighted"
                    v-model="productDetailPop.item.unit_mrp"
                    disabled
                  />
                </b-col>
                <b-col md="3">
                  <label for>&nbsp;</label>
                  <p class="mt-2 price-overide">
                    <b-link
                      id="price-override-productpopup"
                      :disabled="
                        !productDetailPop.item.is_priceoverride_active ||
                          productDetailPop.item.price_override == 1 ||
                          state.system.isOffline ||
                          state.system.settings.cart.price_override.status == 0
                      "
                      :style="
                        !productDetailPop.item.is_priceoverride_active ||
                        productDetailPop.item.price_override == 1 ||
                        state.system.settings.cart.price_override.status == 0
                          ? 'cursor: no-drop; opacity: 0.5;'
                          : null
                      "
                      @click="
                        $refs['price-override-modal'].show(),
                          (price_override = { value: '', is_error: false })
                      "
                    >
                      <span class="text-center">{{ currencySymbol }}</span>
                      {{
                        productDetailPop.item.price_override == 1
                          ? "Price Overriden"
                          : "Price Override"
                      }}
                    </b-link>
                  </p>
                </b-col>

                <!-- <div class="col">
                  <label for class="pl-0">Quantity</label>
                  <b-form-group id="input-group-1">
                    <b-form-input
                      id
                      type="text"
                      required
                      :value="productDetailPop.item.qty"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </div>-->
              </b-row>
              <b-row class="mt-3">
                <b-col md="6">
                  <label for>Item Manual Discount</label>
                  <div v-if="!state.system.isOffline">
                    <div
                      @click="openItemManualDiscountModal"
                      v-if="
                        productDetailPop.item.manual_discount.item_md ==
                          '0.00' ||
                          productDetailPop.item.manual_discount.item_md == '0'
                      "
                    >
                      <b-input-group class="select-batch">
                        <b-form-input
                          class="fs-11"
                          placeholder="Add manual discount"
                          disabled
                          id="item-manual-discount-productpopup"
                        />
                        <template v-slot:append>
                          <font-awesome-icon :icon="['fas', 'angle-right']" />
                        </template>
                      </b-input-group>
                    </div>
                    <div
                      v-else
                      @click="
                        removeManualDiscount(
                          productDetailPop.item.cart_id,
                          productDetailPop.item.barcode,
                          productDetailPop.item.unit_mrp
                        )
                      "
                    >
                      <b-input-group class="select-batch highlighted">
                        <b-form-input
                          class="fs-11"
                          v-model="
                            productDetailPop.item.manual_discount.item_md
                          "
                          disabled
                        />
                        <template v-slot:append>
                          <font-awesome-icon :icon="['fas', 'times']" />
                        </template>
                      </b-input-group>
                    </div>
                  </div>
                  <div v-if="state.system.isOffline">
                    <b-input-group class="select-batch">
                      <b-form-input
                        class="fs-11"
                        style="cursor: no-drop;"
                        placeholder="Manual discount disabled"
                        disabled
                      />
                    </b-input-group>
                  </div>
                </b-col>
                <b-col md="6">
                  <label for id="label-promotion-productpopup"
                    >Active Promotion</label
                  >
                  <div v-if="!state.system.isOffline">
                    <custom-dropdown
                      class="fs-11 promo-list"
                      :options="availableOffers"
                      :currentValue="
                        productDetailPop.item.offer_data.applied_offers
                          .length == 0
                          ? 'View Available Promotion(s)'
                          : productDetailPop.item.offer_data.applied_offers[0]
                              .message
                      "
                    />
                  </div>
                  <div v-else>
                    <b-form-input
                      class="fs-11"
                      style="cursor: no-drop;"
                      placeholder="Promotions disabled"
                      disabled
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col md="6">
                  <label for id="label-remark-productpopup">Item Remark</label>
                  <b-form-input
                    placeholder="Add a remark "
                    v-model="productDetailPop.item.remark"
                    class="fs-11"
                    id="input-remark-productpopup"
                  />
                  <!--<b-input-group>
                    <b-form-input
                      v-model="productDetailPop.item.remark"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        @click="
                          saveItemRemark(
                            productDetailPop.item.cart_id,
                            productDetailPop.item.remark
                          )
                        "
                      >
                        <span v-if="$loading == false">Save</span>
                        <b-spinner small v-if="$loading == true"></b-spinner>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>-->
                </b-col>
                <b-col md="6">
                  <label for id="label-salesperson-productpopup"
                    >Assigned Salesperson</label
                  >
                  <div v-if="!state.system.isOffline">
                    <custom-dropdown
                      v-if="checkSalespersonStatus.value"
                      class="fs-11"
                      :options="AvaliableSalespersons"
                      :currentValue="
                        productDetailPop.item.salesman_id == '0' ||
                        productDetailPop.item.salesman_id == null
                          ? checkSalespersonStatus.message
                          : productDetailPop.item.salesman_id
                      "
                      :searchable="true"
                      :type="'salesperson'"
                      @remove-salesman="removeSalesman"
                      @update-value="currentSalesperson"
                    />
                    <b-form-input
                      v-if="!checkSalespersonStatus.value"
                      :placeholder="checkSalespersonStatus.message"
                      disabled
                      style="cursor: default;"
                      class="fs-11"
                    />
                  </div>
                  <div v-else>
                    <b-form-input
                      class="fs-11"
                      style="cursor: no-drop;"
                      placeholder="Tagging Salesperson is disabled"
                      disabled
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <hr class="w-100" />
                  <b-row>
                    <b-col md="3">
                      <label class="pl-0" for>Subtotal</label>
                      <p class="mb-0">
                        {{
                          currencySymbol +
                            formatAmount(
                              parseFloat(productDetailPop.item.amount) -
                                parseFloat(productDetailPop.item.tax_amount)
                            )
                        }}
                      </p>
                    </b-col>
                    <b-col md="3">
                      <label class="pl-0" for>Cumulative Discount</label>
                      <p class="mb-0" v-text="productDetailPop.item.discount" />
                    </b-col>
                    <b-col md="3">
                      <label class="pl-0" for>Product Taxes</label>
                      <p
                        class="mb-0"
                        v-text="
                          currencySymbol +
                            formatAmount(productDetailPop.item.tax_amount)
                        "
                      />
                    </b-col>
                    <b-col md="3">
                      <label class="pl-0" for>Product Total</label>
                      <p
                        class="mb-0"
                        v-text="
                          currencySymbol +
                            formatAmount(productDetailPop.item.amount)
                        "
                      />
                    </b-col>
                  </b-row>
                  <hr class="w-100" />
                </b-col>
              </b-row>
            </div>

            <!-- <div>
              <label for class="pl-0">Promotions</label>
              <p v-if="productDetailPop.item.promotion == ''">No Promotions Available</p>
              <ul class="promotions-list list-group" v-else>
                <li class="list-group-item d-flex align-items-center selected">
                  <font-awesome-layers class="mr-3">
                    <font-awesome-icon :icon="['fas', 'check-circle']" size="1x" />
                  </font-awesome-layers>
                  {{ productDetailPop.item.promotion }}
                </li>
              </ul>
            </div>-->
          </div>
          <b-col md="12" class="text-right w-100">
            <b-button
              id="check-inventory-btn"
              @click="getProductInventory"
              :disabled="$loading"
              variant="outline-primary"
            >
              <span v-if="!$loading || btnName != 'inventory'"
                >Check Inventory</span
              >
              <b-spinner small v-if="$loading && btnName == 'inventory'" />
            </b-button>
            <b-button
              class="ml-2"
              variant="primary"
              :disabled="$loading"
              id="update-product-btn"
              @click="
                saveItemRemark(
                  productDetailPop.item.cart_id,
                  productDetailPop.item.remark
                )
              "
            >
              <span v-if="!$loading || btnName != 'update'"
                >Update Product</span
              >
              <b-spinner small v-if="$loading && btnName == 'update'" />
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <!--Error modal for already applied discount-->
    <b-modal id="MD-applied" size="sm" hide-footer hide-header centered>
      <p class="mb-3 fs-14 d-flex">
        <img src="../assets/images/alert.svg" class="mr-2" alt /> Bill Discount
        Already Applied
      </p>
      <p class="fs-12" v-text="MDBillAppliedMSg"></p>
      <b-button
        variant="primary"
        class="float-right mt-2"
        @click="$bvModal.hide('MD-applied'), ($loading = false)"
        id="dismiss-btn-md"
      >
        Dismiss
      </b-button>
    </b-modal>

    <manual-discount
      :open="openMDBox"
      @close-manual-discount="closeItemManualDiscountModal"
      :bill_type="'ITEM_LEVEL'"
      :pdata="productDetailPop.item"
    />
    <select-batch-modal
      :open="openLGBox"
      @close-batch-modal="closeBatchModal"
      :options="batchList"
    />
    <update-qty-modal
      :open="openBox"
      :data="productDetails"
      @close-modal="boxClose"
      :toCart="true"
    />
    <message-box
      :open="error"
      @close-message="flushError"
      :message="errorMsg"
    />
    <b-modal size="sm" centered hide-footer ref="price-override-modal">
      <template v-slot:modal-title>Price Override</template>
      <div class="d-block">
        <b-form-group
          id="input-group-1"
          label="Enter Custom Price"
          label-for="Cust-Price"
        >
          <b-form-input
            id="Cust-Price"
            name="Cust-Price"
            type="number"
            aria-describedby="price-live-feedback"
            v-model="price_override.value"
            :placeholder="currencySymbol + '0.00'"
            autofocus
            autocomplete="off"
            style="border: none;"
            @input="price_override.is_error = false"
          />

          <p
            class="text-danger"
            v-if="price_override.is_error"
            v-text="price_override.error_message"
          />
        </b-form-group>
      </div>
      <div class="mt-4 text-right">
        <b-button
          variant="primary"
          :disabled="$loading || price_override.value == ''"
          @click="checkPriceOverride"
          id="apply-price-override-btn"
        >
          <span v-if="!$loading">Apply Override</span>
          <b-spinner small v-if="$loading" />
        </b-button>
      </div>
    </b-modal>
    <b-modal
      centered
      size="md"
      ref="inventory-modal"
      id="inventory-modal"
      hide-footer
      :title="
        productDetailPop != ''
          ? 'Inventory | ' +
            productDetailPop.item.name +
            ' (' +
            productDetailPop.item.barcode +
            ')'
          : 'Inventory'
      "
    >
      <div
        style="min-height: 320px; max-height: 320px;"
        class="overflow-auto item-list mt-1 mb-1"
      >
        <div
          v-if="inventoryData.length == 0"
          class="d-flex justify-content-center align-items-center"
          style="min-height: 320px; max-height: 320px;"
        >
          <p>No data found.</p>
        </div>
        <div v-if="inventoryData.length > 0">
          <ul class="list-unstyled stockpoint-name">
            <li
              v-for="stockpoints in inventoryData"
              :key="stockpoints.stock_point_id"
              class="px-2 py-2"
            >
              <div>
                <p class="m-0">
                  <span v-text="stockpoints.stock_point_name.toUpperCase()" />
                  <span
                    class="mr-2 float-right"
                    :style="
                      stockpoints.qty_is == 'deficit'
                        ? 'color: #ff6666;'
                        : 'color: #28a745;'
                    "
                    v-text="stockpoints.qty"
                  />
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- <b-row class="float-right">
        <b-button class="grey-btn mt-2 mr-1" @click="$refs['inventory-modal'].hide()">Close</b-button>
      </b-row>-->
    </b-modal>
  </div>
</template>

<script>
import { BModal } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";
import { faCheckCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { mapState } from "vuex";
import img from "../assets/images/no-img-lg.png";
import UpdateQtyModal from "./UpdateQtyModal";
import axios from "axios";
import * as msg from "../message";
import MessageBox from "../components/MessageBox";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import CustomDropdown from "../components/CustomDropdown";
import SelectBatchModal from "../components/SelectBatchModal";
import ManualDiscount from "./ManualDiscount";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
library.add(faPlusSquare, faCheckCircle, faPlusCircle);

export default {
  mixins: [validationMixin],
  name: "cart-table",
  props: {
    salesPersonSelected: {},
    isContentShow: Boolean,
    isHide: Boolean,
    // refundMode: Boolean
  },
  components: {
    BModal,
    UpdateQtyModal,
    MessageBox,
    CustomDropdown,
    SelectBatchModal,
    ManualDiscount,
    CoolLightBox,
  },
  data() {
    return {
      openBox: false,
      products: [],
      productDetails: "",
      searchableName: true,
      isHidden: false,
      openMDBox: false,
      openLGBox: false,
      remark: "",
      // manualDiscount: "",
      productDetailPop: "",
      MDBillAppliedMSg: msg.BILL_MD_ALREADY_APPLIED,
      varientsPlaceholder: "Select Varient",
      isBusy: false,
      selectedItem: [],
      error: false,
      selectedQty: "",
      btnName: "update",
      inventoryData: [],
      noImage: false,
      errorMsg: {
        btnText: "",
        text: "",
        type: "",
      },

      fields: [
        { key: "id", label: "#", class: "text-center align-middle w-5" },
        {
          key: "name",
          label: "Product Name(s)",
          class: "text-left  align-middle",
        },
        { key: "qty", label: "Quantity", class: "align-middle" },
        {
          key: "sale_price",
          label: "Sale Price",
          class: "text-right  align-middle",
        },
        {
          key: "discount",
          label: "Discount",
          class: "text-right  align-middle",
        },
        {
          key: "net_price",
          label: "Net Price",
          class: "text-right  align-middle",
        },
        { key: "cart_id", label: "", class: "text-center  align-middle" },
      ],
      cartQty: "1",
      // form: {
      //   price: "",
      // },
      price_override: { value: "", is_error: false, error_message: "" },
      batchList: [
        {
          number: "BATC000000000000",
          MRP: "₹500.00",
          manu_date: "20 Dec 2019",
          exp_date: "20 Apr 2020",
          val_date: "4 months",
          available_qty: "224",
        },
        {
          number: "BATC000000000001",
          MRP: "₹500.00",
          manu_date: "20 Dec 2019",
          exp_date: "20 Apr 2020",
          val_date: "4 months",
          available_qty: "96",
        },
        {
          number: "BATC000000000002",
          MRP: "₹500.00",
          manu_date: "20 Dec 2019",
          exp_date: "20 Apr 2020",
          val_date: "4 months",
          available_qty: "10",
        },
        {
          number: "BATC000000000003",
          MRP: "₹500.00",
          manu_date: "20 Dec 2019",
          exp_date: "20 Apr 2020",
          val_date: "4 months",
          available_qty: "5",
        },
        {
          number: "BATC000000000004",
          MRP: "₹500.00",
          manu_date: "20 Dec 2019",
          exp_date: "20 Apr 2020",
          val_date: "4 months",
          available_qty: "5",
        },
      ],
      productImages: [
        {
          src:
            "https://rukminim1.flixcart.com/image/416/416/kddf6a80/chocolate/u/q/s/126-dairy-milk-home-treats-chocolate-cadbury-original-imafuak6ghfz3zmz.jpeg?q=70",
        },
        {
          src:
            "https://rukminim1.flixcart.com/image/416/416/kddf6a80/chocolate/u/q/s/126-dairy-milk-home-treats-chocolate-cadbury-original-imafuak6cwqtmykj.jpeg?q=70",
        },
        {
          src:
            "https://rukminim1.flixcart.com/image/416/416/kd4uj680/chocolate/y/n/c/378-dairy-milk-chocolate-home-treats-126g-pack-of-3-cadbury-original-imafu3wtdcscdcmn.jpeg?q=70",
        },
        {
          src:
            "https://rukminim1.flixcart.com/image/416/416/kd4uj680/chocolate/y/n/c/378-dairy-milk-chocolate-home-treats-126g-pack-of-3-cadbury-original-imafu3wthjhyjagh.jpeg?q=70",
        },
      ],
      index: null,
    };
  },
  created() {
    if (this.state.billing.billing.dumuy_customer != "") {
      this.$store.dispatch("billing/cartDetails");
    }
  },
  validations() {
    return {
      form: {
        price: {
          required,
          maxLength: maxLength(4),
        },
      },
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    checkSalespersonStatus() {
      let check = {
        value: false,
        message: "Assign salesperson in not enabled",
      };
      this.state.system.settings.cart_menu.map((item) => {
        if (item.name == "assign_salesman" && item.status == 1) {
          if (this.state.billing.billing.salesPerson.data.length > 0) {
            check.value = true;
            check.message = "Select Salesperson";
          } else if (this.state.billing.billing.salesPerson.data.length == 0) {
            check.value = false;
            check.message = "No salesperson found in this store.";
          }
        }
      });
      return check;
    },
    AvaliableSalespersons() {
      let data = [];
      if (this.state.billing.billing.salesPerson.data.length > 0) {
        this.state.billing.billing.salesPerson.data.forEach((element) => {
          data.push({
            value: element.first_name + " " + element.last_name,
            id: element.salesman_id,
          });
        });
      }
      return data;
    },
    /*fetchRemark(){
      if(productDetailPop!='' )

       this.productDetailPop.item =
    },*/
    // popupImages() {
    //   let data = [];
    //   this.productDetailPop.item.images.map((item, index) => {
    //     this.item = data;
    //     // console.log(data);
    //   });
    //   return data;
    // },

    cartDetails() {
      let data = [];
      if (this.state.billing.billing.cart != "") {
        this.state.billing.billing.cart.data.map((item, index) => {
          let available_qty = 0;
          let promotion = "";
          let promoList = [];
          let images = [];
          if (item.product_data.offer == "Yes") {
            promotion = item.product_data.offer_data.applied_offers[0].message;
            item.product_data.offer_data.available_offers.map((promo) => {
              if (promo.message == promotion) {
                promoList.push({ msg: promo.message, applied: 1 });
              } else {
                promoList.push({ msg: promo.message, applied: 0 });
              }
            });
          } else {
            promotion = "";
          }

          // Check Negative Stock Allowed or not
          // if (this.checkNegativeStockBill) {
          //   available_qty = 50;
          // } else {
          //   available_qty = item.product_data.current_stock;
          // }
          if (this.checkNegativeStockBill) {
            if (
              this.state.system.settings.cart != "" &&
              this.state.system.settings.cart.hasOwnProperty("product_max_qty")
            ) {
              available_qty = parseInt(
                this.state.system.settings.cart.product_max_qty
              );
            } else {
              available_qty = 50;
            }
          } else {
            if (
              this.state.system.settings.cart != "" &&
              this.state.system.settings.cart.hasOwnProperty("product_max_qty")
            ) {
              if (
                this.state.system.settings.cart.product_max_qty <
                item.product_data.current_stock
              ) {
                available_qty = this.state.system.settings.cart.product_max_qty;
              } else {
                available_qty = item.product_data.current_stock;
              }
            } else {
              available_qty = item.product_data.current_stock;
            }
          }

          // Check Images on array
          if (item.product_data.hasOwnProperty("images_array")) {
            if (item.product_data.images_array.length > 0) {
              images = item.product_data.images_array;
            } else {
              images.push(item.product_data.images);
            }
          } else {
            images.push(item.product_data.images);
          }

          if (this.state.billing.billing.billing_mode == "order") {
            available_qty = this.state.system.settings.cart.product_max_qty;
          }

          data.push({
            id: index + 1,
            cart_id: item.cart_id,
            name: item.product_data.p_name,
            qty: item.qty,
            sale_price:
              this.currencySymbol +
              this.formatAmount(item.product_data.r_price),
            discount:
              this.currencySymbol +
              this.formatAmount(item.product_data.discount),
            net_price: this.currencySymbol + this.formatAmount(item.amount),
            promotion: promotion,
            brand_name: item.product_data.brand_name,
            barcode: item.product_data.barcode,
            product_id: item.product_data.p_id,
            promo_list: promoList,
            remark: item.product_data.remark,
            salesman_id: item.salesman_id,
            price_list: item.product_data.multiple_mrp,
            unit_mrp: item.product_data.unit_mrp,
            batch: item.product_data.batch,
            stock: item.product_data.current_stock,
            tax_amount: item.tax_amount,
            amount: item.amount,
            available_qty: available_qty,
            images: images,
            image_link: this.state.billing.billing.cart.product_image_link,
            variant: item.product_data.varient,
            weight: item.product_data.weight_flag,
            uom: item.product_data.uom,
            manual_discount: item.product_data.manual_discount,
            s_price: item.product_data.s_price,
            r_price: item.product_data.r_price,
            batch_id: item.product_data.hasOwnProperty("batch_id")
              ? item.product_data.batch_id
              : 0,
            serial_id: item.product_data.hasOwnProperty("serial_id")
              ? item.product_data.serial_id
              : 0,
            price_override: item.price_override,
            is_priceoverride_active: item.product_data.is_priceoverride_active,
            offer_data: item.product_data.offer_data,
            t_data: JSON.parse(item.product_data.tdata),
          });
        });
      }
      return data;
    },

    checkNegativeStockBill() {
      let check = false;
      if (this.state.system.settings.stock.negative_stock_billing.status == 1) {
        check = true;
      }
      return check;
    },
    swapImage() {
      let mainImg = document.querySelector(".main-img img");
      let thumbImg = document.querySelectorAll(".thumb-imgs img");
      for (let i = 0; i < thumbImg.length; i++) {
        let images = thumbImg[i];
        images.onClick(function() {
          // console.log("asd");
        });
      }
      //console.log(mainImg);
      console.log(mainImg);

      return this;
    },
    QtyOptions() {
      let data = [];
      for (var i = 1; i <= this.productDetailPop.item.available_qty; i++) {
        data.push({ value: i });
      }
      return data;
    },
    isManualDiscountApplied() {
      let check = false;
      if (this.state.billing.billing.cart.hasOwnProperty("bill_summary"))
        this.state.billing.billing.cart.bill_summary.forEach((summary) => {
          if (summary.name == "manual_discount")
            summary.type.forEach((item) => {
              if (item.name == "bill_level") check = true;
            });
        });
      return check;
    },
    availableOffers() {
      let data = [];
      this.productDetailPop.item.offer_data.available_offers.forEach(
        (item, index) => {
          data.push({ value: item.message, id: index });
        }
      );
      return data;
    },
    getBillingMode() {
      return this.state.billing.billing.billing_mode == "normal" ||
        this.checkEmpty(this.state.billing.billing.billing_mode)
        ? "billing"
        : this.state.billing.billing.billing_mode;
    },
  },
  // watch: {
  //   isHide: function() {
  //     if (this.isHide == false) {
  //       this.$nextTick(() => {
  //         this.$refs.cartProducts.clearSelected();
  //       });
  //     }
  //   }
  // },
  mounted() {
    this.cartDetails;
    this.productPopData;
    this.outStock();
    // this.onChangeTheme();
    //this.swapImage();
  },
  updated() {
    if (
      this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
      this.state.system.settings.vendor_app_menu.offline.status == 1 &&
      this.state.system.isOffline == true
    ) {
      if (this.state.billing.billing.cart.length != 0) {
        this.checkManualDiscount();
      }
    }
  },
  methods: {
    setIndex(index) {
      this.index = index;
    },
    removeSalesman() {
      this.$loading = true;
      let postData = {
        // c_id: this.state.c_id,
        all: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        cart_id: this.productDetailPop.item.cart_id,
        trans_from: this.state.system.trans_from,
        salesman_id: this.productDetailPop.item.salesman_id,
        // udidtoken: this.state.trans_from,
        check: "0",
        url: "/vendor/untag-salesman ",
      };
      let dataAxios = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(dataAxios.url, dataAxios)
        .then(() => {
          let alertData = {
            message: msg.SALESPERSON_UNTAGGED,
            type: "success",
          };

          this.$store.dispatch("billing/cartDetails").then(() => {
            this.getProductData(
              this.productDetailPop.item.barcode,
              this.productDetailPop.item.unit_mrp
            );
            this.$loading = false;
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          });
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    getProductInventory() {
      this.$loading = true;
      this.btnName = "inventory";
      let postData = {
        barcode: this.productDetailPop.item.barcode,
        batch_id: this.productDetailPop.item.batch_id,
        serial_id: this.productDetailPop.item.serial_id,
        url: "/check-product-inventory",
      };
      let data = Object.assign(postData, this.customerData);
      axios
        .post(data.url, data)
        .then((res) => {
          this.inventoryData = res.data.data;
          this.$refs["inventory-modal"].show();
          this.$loading = false;
          this.btnName = "update";
        })
        .catch(() => {
          this.$loading = false;
          this.btnName = "update";
        });
    },
    checkPriceOverride() {
      this.$loading = true;
      let postData = {
        barcode: this.productDetailPop.item.barcode,
        unit_mrp: parseFloat(this.productDetailPop.item.unit_mrp).toFixed(2),
        override_price: this.price_override.value,
        url: "/check-override-limit",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "fail") {
            this.price_override.is_error = true;
            this.price_override.error_message = res.data.message;
            this.$loading = false;
          } else {
            this.$store
              .dispatch("billing/getPriceOverride", {
                pdata: this.productDetailPop.item,
                override_price: this.price_override.value,
              })
              .then(() => {
                this.$refs["price-override-modal"].hide();
                this.$loading = false;
                this.getProductData(
                  postData.barcode,
                  parseFloat(postData.override_price).toFixed(2)
                );
                let alertData = {
                  message: msg.PRICE_OVERRIDE_SUCCESS,
                  type: "success",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
              })
              .catch(() => (this.$loading = false));
          }
        })
        .catch(() => [(this.$loading = false)]);
    },
    removeManualDiscount(cart_id, barcode, unit_mrp) {
      this.$loading = true;
      let postData = {
        store_id: this.state.sessions.user.store_id,
        remove_discount: "1",
        trans_from: this.state.system.trans_from,
        api_token: this.state.sessions.user.api_token,
        url: "/manual-discount",
        cart_id: cart_id,
        applicable_level: "ITEM_LEVEL",
        manual_discount_factor: "",
        manual_discount_basis: "",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };

      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then((res) => {
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.getProductData(barcode, unit_mrp);
            this.$loading = false;
            let alertData = {};
            if (res.data.status == "fail")
              alertData = {
                message: res.data.message,
                type: "danger",
              };
            else
              alertData = {
                message: "Item level " + msg.REMOVED_MANUAL_DISCOUNT,
                type: "success",
              };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          });
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    getProductData(barcode, unit_mrp) {
      let prod = this.state.billing.billing.cart.data.filter((item) => {
        if (
          item.product_data.barcode == barcode &&
          item.product_data.unit_mrp == unit_mrp
        )
          return item;
      });
      if (prod.length > 0) {
        this.productDetailPop.item.manual_discount =
          prod[0].product_data.manual_discount;
        this.productDetailPop.item.remark = prod[0].product_data.remark;
        this.productDetailPop.item.salesman_id = prod[0].salesman_id;
        this.productDetailPop.item.tax_amount = prod[0].tax_amount;
        this.productDetailPop.item.amount = prod[0].amount;
        this.productDetailPop.item.discount =
          this.currencySymbol +
          this.formatAmount(prod[0].product_data.discount);
        this.productDetailPop.item.unit_mrp = prod[0].product_data.unit_mrp;
        this.productDetailPop.item.cart_id = prod[0].cart_id;
        this.productDetailPop.item.price_override = prod[0].price_override;
      }
    },
    currentSalesperson(value) {
      this.$loading = true;
      let postData = {
        // c_id: this.state.c_id,
        all: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        cart_id: this.productDetailPop.item.cart_id,
        trans_from: this.state.system.trans_from,
        salesman_id: value.id,
        udidtoken: this.state.system.trans_from,
        check: "1",
        url: "/vendor/tag-salesman",
      };
      let dataAxios = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(dataAxios.url, dataAxios)
        .then(() => {
          let alertData = {
            message: msg.SALESPERSON_TAGGED,
            type: "success",
          };
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.getProductData(
              this.productDetailPop.item.barcode,
              this.productDetailPop.item.unit_mrp
            );
            this.$store.commit("notifications/showAlert", alertData);
            this.$showAlert = true;
            this.$loading = false;
          });
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    updateQtyPopUp(value) {
      this.updateToCart(this.productDetailPop.item, value.value, "popup");
    },
    openSelectBatchModal() {
      this.openLGBox = false;
    },
    openItemManualDiscountModal() {
      if (this.isManualDiscountApplied) {
        console.log("remove bill level disc first");
        this.$bvModal.show("MD-applied");
        // this.state.notifications.message.text = msg.BILL_MD_ALREADY_APPLIED;
        // this.state.notifications.message.btnText = "Dismiss";
        // this.state.notifications.message.type = "";
      } else this.openMDBox = true;
    },
    closeBatchModal(data) {
      this.openLGBox = data;
    },
    closeItemManualDiscountModal(data) {
      this.openMDBox = data;
      this.getProductData(
        this.productDetailPop.item.barcode,
        this.productDetailPop.item.unit_mrp
      );
    },
    checkManualDiscount() {
      let manual_discount = 0;
      this.state.billing.billing.cart.bill_summary.map((item) => {
        if (item.name == "manual_discount") {
          manual_discount = parseFloat(item.value);
        }
      });
      if (
        parseFloat(this.state.billing.billing.total_payable) <= 0 &&
        manual_discount > 0
      ) {
        this.removeDiscount();
        this.error = true;
        this.errorMsg.btnText = "Close";
        this.errorMsg.text = msg.INVALID_MANUAL_DISCOUNT;
      }
    },
    removeDiscount() {
      this.$loading = true;
      let postData = {
        store_id: this.state.sessions.user.store_id,
        manual_discount_basis: "",
        remove_discount: "1",
        trans_from: this.state.system.trans_from,
        api_token: this.state.sessions.user.api_token,
        manual_discount_factor: "",
        url: "/manual-discount",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };

      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then(() => {
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.$loading = false;
          });
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    saveItemRemark(cartID, remark) {
      this.$loading = true;
      let data = {
        // c_id: this.state.c_id,
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        cart_id: cartID,
        trans_from: this.state.system.trans_from,
        cart_remark: remark,
        url: "/add-remark",
      };
      // console.log(postData);
      let postdata = Object.assign(
        data,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, postdata)
        .then(() => {
          // this.carryBags = response.data.data;
          // this.state.billing = data.Qty;
          //console.log(response.data.s)
          // this.cart_remark = this.remark;
          this.$loading = false;
          this.$refs["product-detail"].hide();
          // this.remark = "";

          // let alertData = {
          //   message: response.data.message,
          //   type: "success",
          // };

          // this.$showAlert = true;
          // this.$store.commit("notifications/showAlert", alertData);
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    imageUrlAlt(e) {
      e.target.src = img;
      this.noImage = true;
      console.log("Image Broken");
    },
    showProductDetail(data) {
      this.$refs["product-detail"].show();
      this.productDetailPop = data;
    },
    updateToCart(pdata, value, src) {
      var proData = "";
      if (this.state.billing.billing.cart.data.length != 0) {
        this.state.billing.billing.cart.data.map((item) => {
          if (
            item.product_data.barcode == pdata.barcode &&
            item.product_data.unit_mrp == pdata.unit_mrp
          ) {
            proData = item.product_data;
            // console.log(proData);
          }
        });
      }
      this.selectedQty = value;
      this.$loading = true;
      let productData = {
        barcode: pdata.barcode,
        scan: "TRUE",
        url: "product-qty-update",
        qty: value,
        change_mrp: "",
        unit_mrp: proData.unit_mrp,
        r_price: proData.r_price,
        s_price: proData.s_price,
        amount: "",
        discount: "",
        pdata: "",
        batch_id: proData.hasOwnProperty("batch_id") ? proData.batch_id : "0",
        serial_id: proData.hasOwnProperty("serial_id")
          ? proData.serial_id
          : "0",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };
      let data = Object.assign(
        productData,
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/updateToCart", data)
        .then(() => {
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.$loading = false;
            if (src == "popup")
              this.getProductData(pdata.barcode, proData.unit_mrp);
          });
        })
        .catch(() => {
          this.$loading = false;
        });

      // let cartQuantity = this.calQuantity(pdata);
      // let checkValue = parseInt(cartQuantity) + parseInt(value);
      // if (checkValue < parseInt(this.state.billing.cart.cart_max_item)) {
      //   //c
      // } else {
      //   console.log("reached");
      //   let alertData = {
      //     message: msg.MAX_CART_ITEMS,
      //     type: "danger"
      //   };
      //   this.$store.commit("showAlert", alertData);
      //   this.$showAlert = true;
      // }
    },
    removeProduct(pdata) {
      // console.log(value);
      this.$loading = true;
      let productData = {
        barcode: pdata.barcode,
        url: "remove-product-from-cart",
        product_id: pdata.product_id,
        cart_id: pdata.cart_id,
        all: "",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };
      let data = Object.assign(
        productData,
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/removeProduct", data)
        .then(() => {
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.$loading = false;
          });
        })
        .catch(() => {
          this.$loading = false;
        });
      this.$refs.cartProducts.clearSelected();
      if (this.isContentShow == false && this.isHide == false) {
        this.$emit("hide-salesp");
      }
    },
    getProductDetails(data) {
      if (data.length > 0) this.$emit("get-product-info", data[0]);
      else this.$emit("get-product-info", "");
      // this.$emit("hide-salesp");
    },
    outStock(item) {
      if (!item) return;
      if (item.stock < 0) {
        return "b-table-row-outofstock";
      }
      return false;
    },
    boxClose(data) {
      this.openBox = data;
    },
    updateQty(data) {
      this.openBox = true;
      let postData = {
        barcode: data.barcode,
        category: "",
        unit_mrp: data.unit_mrp,
        item_name: data.name,
        qty: data.qty,
        uom: data.uom,
        change_mrp: data.unit_mrp,
        batch_id: data.batch_id,
        serial_id: data.serial_id,
      };
      this.productDetails = postData;
      if (typeof Android !== "undefined" && Android !== null) {
        let postData = { type: "read_weight", data: "" };
        returnValue(postData);
      }
    },
    assignSalePerson(data) {
      // let checkValue = 0;
      // console.log(data);
      // this.state.billing.salesPerson.selected = data;
      this.state.billing.billing.cart.data.map((item) => {
        if (item.cart_id == data.cart_id && !item.salesman_id == "") {
          item.salesman_id = null;
          this.$loading = true;
          let postData = {
            // c_id: this.state.c_id,
            all: "",
            api_token: this.state.sessions.user.api_token,
            v_id: this.state.sessions.user.v_id,
            store_id: this.state.sessions.user.store_id,
            vu_id: this.state.sessions.user.vu_id,
            cart_id: item.cart_id,
            trans_from: this.state.system.trans_from,
            salesman_id: this.salesPersonSelected.id,
            udidtoken: this.state.system.trans_from,
            check: "0",
            url: "/vendor/tag-salesman",
          };
          let dataAxios = Object.assign(
            postData,
            this.essentialsData,
            this.customerData
          );
          axios
            .post(dataAxios.url, dataAxios)
            .then(() => {
              let alertData = {
                message: msg.SALESPERSON_UNTAGGED,
                type: "success",
              };
              this.$store.commit("notifications/showAlert", alertData);
              this.$store.dispatch("billing/cartDetails");
              this.$loading = false;
              this.$showAlert = true;
            })
            .catch(() => {
              this.$loading = false;
            });
        } else if (item.cart_id == data.cart_id) {
          item.salesman_id = this.salesPersonSelected.id;
          this.$loading = true;
          let postData = {
            // c_id: this.state.c_id,
            all: "",
            api_token: this.state.sessions.user.api_token,
            v_id: this.state.sessions.user.v_id,
            store_id: this.state.sessions.user.store_id,
            vu_id: this.state.sessions.user.vu_id,
            cart_id: item.cart_id,
            trans_from: this.state.system.trans_from,
            salesman_id: this.salesPersonSelected.id,
            udidtoken: this.state.system.trans_from,
            check: "1",
            url: "/vendor/tag-salesman",
          };
          let dataAxios = Object.assign(
            postData,
            this.essentialsData,
            this.customerData
          );
          axios
            .post(dataAxios.url, dataAxios)
            .then(() => {
              // alert("1243");
              let alertData = {
                message: msg.SALESPERSON_TAGGED,
                type: "success",
              };
              this.$store.commit("notifications/showAlert", alertData);
              this.$store.dispatch("billing/cartDetails");
              this.$loading = false;
              this.$showAlert = true;
            })
            .catch(() => {
              this.$loading = false;
            });
          //Assigning a salesperson to a product
        }

        return item;
      });
    },
    isChecked(data) {
      let check = false;
      if (data != "" && data != null && data != 0) {
        check = true;
      }
      return check;
    },
    flushError() {
      this.error = false;
      this.errorMsg = {
        btnText: "",
        text: "",
        type: "",
      };
    },
    splitTextOnBreakPoint(val) {
      let len = 30;
      if (window.screen.availWidth <= 992 && window.screen.availWidth > 977)
        len = 19;
      else if (
        window.screen.availWidth <= 977 &&
        window.screen.availWidth > 963
      )
        len = 18;
      else if (window.screen.availWidth <= 963) len = 17;
      return `${val.substring(0, len)}...`;
    },
    // calQuantity(pdata) {
    //   let updatedqty = 0;
    //   this.state.billing.cart.data.map(item => {
    //     if (pdata.product_id != item.product_data.p_id) {
    //       updatedqty += parseInt(item.qty);
    //     }
    //   });
    //   return updatedqty;
    // }
    /* onChangeTheme() {
      let themeClass = document.querySelector("#theme");
      if (themeClass == "theme-dark") {
        this.$store.dispatch("changeTheme", "theme-light");
        themeClass.classList.remove("theme-dark");
        themeClass.classList.add("theme-light");
        console.log("theme-light");
      } else {
        this.$store.dispatch("changeTheme", "theme-dark");
        themeClass.classList.remove("theme-light");
        themeClass.classList.add("theme-dark");
        console.log("theme-dark");
      }
   }*/
  },
};
</script>
<style lang="scss" scoped>
.highlighted.form-control:disabled {
  border: 1px solid #c0c0c0 !important;
  background: transparent;
  user-select: none;
  cursor: not-allowed !important;
}
.modal-body input {
  height: auto;
}
h6 {
  color: $mid-grey;
}
.barcode {
  color: #606060;
}
.form-control:focus {
  border: 0;
  box-shadow: none;
}
.theme-light .light-img,
.theme-dark .dark-img {
  display: block;
}
.theme-light .dark-img,
.theme-dark .light-img {
  display: none;
}
.theme-dark .form-control {
  background-color: #303030;
}
.billing-table .text-danger:hover td {
  background-color: red !important;
}
.multi-price .price {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
  padding: 10px 0px;
}
.multi-price .price:nth-child(2) {
  border-bottom: none;
}
.list-group-item {
  padding: 10px;
}
.thumb-imgs {
  img {
    height: 100px;
    padding: 10px;
    object-fit: contain;
  }
}
.table-primary .b-table-row-outofstock:focus {
  background: #f0f0f0 !important;
}
tr:hover .custom-select,
tr:focus .custom-select {
  border: 1px #c0c0c0 solid;
}
.theme-dark :hover .custom-select,
.theme-dark :focus .custom-select {
  border: 1px #606060 solid;
}
@media only screen and (max-width: 1300px) {
  .custom-select-sm {
    width: 55px;
  }
}

.select-batch {
  &.highlighted {
    border: 1px solid #c0c0c0;
    border-radius: 0.25rem;
    user-select: none;
    cursor: pointer;
    .input-group-append {
      background: transparent;
    }
    .form-control {
      background: transparent !important;
    }
  }
  .input-group-append {
    cursor: pointer;
    background: #f0f0f0;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding-right: 12px;
    padding-top: 13px;
    margin-left: 0;
    font-size: 12px;
    color: #a0a0a0;
  }
  .form-control {
    cursor: pointer;
    &:disabled {
      background: #f0f0f0;
    }
  }
}
.item-list {
  @include custom-scrollbar();
}
.stockpoint-name li {
  &:first-child {
    padding-top: 0px !important;
  }
  &:nth-child(even) {
    background: #f8f8f8 !important;
  }
}
.theme-dark .stockpoint-name li {
  &:nth-child(even) {
    background: #303030 !important;
  }
}

.theme-dark {
  h5 {
    color: $white-color;
  }
  .barcode {
    color: #c0c0c0;
  }
  .select-batch {
    .input-group-append {
      background: #303030;
    }
  }
  .highlighted {
    border: 1px solid transparent;
    background: #303030;
    &.form-control {
      &:disabled {
        border: 1px solid #606060 !important;
      }
    }
  }
  hr {
    border-color: #404040;
  }
  p {
    color: $dark-card-text;
  }
}
.images-wrapper {
  .image {
    height: 80px;
    width: 100%;
    border-radius: 5px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    color: #fff;
    position: relative;
    cursor: pointer;
    .fa-search-plus {
      display: none;
    }

    &:hover {
      &:before {
        content: "";
        height: 100%;
        width: 100%;
        position: absolute;
        border-radius: 5px;
        background: rgba($color: #000000, $alpha: 0.5);
      }
      .fa-search-plus {
        display: block;
        z-index: 99;
      }
    }
  }
}
</style>
